import {useDispatch, useSelector} from "react-redux";
import {
  setPagesAddingOrEditing,
  tryDeleteDynamicUiPage
} from "../../../redux/slices/dynamicUiSlice";
import ConfirmModal from "../../../components/ConfirmModal";

const DynamicUIPageDeleteModal = () => {

  const dispatch = useDispatch();
  const deleting = useSelector((state) => state.dynamicUi.pages.modify.deleting);
  const { loading: deletingPages} = useSelector((state) => state.dynamicElements.editing);



  const onDelete = () => {

    dispatch(tryDeleteDynamicUiPage({deleting}));
  };



  return (
    <ConfirmModal title="Delete Page"
                  showModal={deleting}
                  setShowModal={() => dispatch(setPagesAddingOrEditing({clear: true}))}
                  children={`Are you sure you want to delete this page${deleting ? ` '${deleting?.title}'` : ''}?`}
                  disabled={deletingPages}
                  onConfirm={onDelete}
    />
  );
};

export default DynamicUIPageDeleteModal;
